import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'

import { compose, pure } from 'recompose'
import { connect } from 'react-redux'
import styles from './styles.scss'
import { Flex } from 'reflexbox'

import ProductList from './List'

import {
    resetProductFields,
    toggleProductHierarchyCollapse
} from '../actions'

const PureProductList = pure(ProductList)
const mapStateToProps = (state) => {
    return {
        isProductHierarchyCollapse: state.project.search.collapseProductHierarchy
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        resetProductFields: () => dispatch(resetProductFields()),
        toggleProductHierarchyCollapse: () => dispatch(toggleProductHierarchyCollapse())
    }
}

class ProductFieldsCard extends Component {
    render() {
        const {
            isProductHierarchyCollapse
        } = this.props
        return (
                <Flex justify='space-between'>
                    <PureProductList isCollapse={isProductHierarchyCollapse} />
                </Flex>
        )
    }
}
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyles = CSSModules(styles)
const enhance = compose(
  withConnect,
  withStyles
)

export default enhance(ProductFieldsCard)